import React, { Component } from 'react';

import Conteudo from '../../Conteudo';
import Title from '../../components/Title';

import ListaPerfis from './ListaPerfis';
import ListaTarefas from './ListaTarefas';

import AuthProvider from '../../AuthProvider';

export default class extends Component {
  render() {
    return (
      <div>
        <Title value="Diego Rivera » Agenda » Tarefas" />
        <AuthProvider>
          {(_undefined, containsRole) => {
            let children = [];

            if (
              containsRole([
                'admin',
                'conselheiro',
                'sindico'
              ])
            ) {
              children.push(ListaPerfis, ListaTarefas);
            }

            return (
              children.length && (
                <Conteudo>
                  {children.map((Child, i) => (
                    <Child key={i} />
                  ))}
                </Conteudo>
              )
            );
          }}
        </AuthProvider>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/agenda/AgendaTarefas.js